import raf from "raf"
import callback from "./util/callback";

import Controls from "./controls";
import Markers from "./util/markers";
import { NoOpControls } from "./controls";

import {
    Scene,
    PerspectiveCamera,
    WebGLRenderer,
    AmbientLight,
    PointLight,
    JSONLoader,
    Quaternion,
    Vector3,
    FogExp2, Mesh, PlaneBufferGeometry, MeshPhongMaterial, TextureLoader, MeshLambertMaterial
} from "three"

import Cannon from "cannon"

import XRacer, { SHIP_MATERIAL } from "./x-racer";
import Entities from "./entities";
import Stats from "./util/stats";
import Cube from "./cube";

const PLAYER_X = 0;
const PLAYER_Y = 0;
const PLAYER_Z = 1.2;

const CAMERA_OFFSET_X = 0;
const CAMERA_OFFSET_Y = -1; //- 3;
const CAMERA_OFFSET_Z = 0.6;

import { TAU, rad } from "./util/math"
import Track, { TRACK_MATERIAL } from "./track";

const STEP_SIZE = 1/60;

// three js
const ctx = {

};

import { SCURVE as TRACK_DATA }  from "./track-data"
//import TRACK_DATA from "./track-data"
//import { HILL as TRACK_DATA }  from "./track-data"

let renderer, camera, prevTime;

let controls;

let statsElem;
let prevStats;

let light;

function mainLoop()
{
    const stats = Stats.toString();
    if (stats !== prevStats)
    {
        statsElem.innerHTML = stats;
        prevStats = stats;
    }

    const now = Date.now();
    let delta = (now - prevTime) / 1000;
    prevTime = now;

    while (delta >= STEP_SIZE)
    {
        ctx.world.step(STEP_SIZE);

        controls.tick();

        delta -= STEP_SIZE;
    }
    ctx.entities.sync();

    const xRacer = ctx.entities.get(0);
    const pos = xRacer.getPosition();

    camera.position.x = pos.x + CAMERA_OFFSET_X;
    camera.position.y = pos.y + CAMERA_OFFSET_Y;
    camera.position.z = pos.z + CAMERA_OFFSET_Z;

    light.position.y = pos.y + 3;
    light.position.z = pos.z + 3;

    renderer.render( ctx.scene, camera);

    raf( mainLoop );
}

function logKeyCode(ev)
{
    console.log("keyCode", ev.keyCode);
}

function init()
{
    const canvas = document.getElementById("screen");

    statsElem = document.createElement("pre");
    statsElem.setAttribute("class", "stats");

    document.body.appendChild(statsElem);

    ctx.entities = new Entities();
    ctx.scene = new Scene();
    Markers.init(ctx);

    const width = window.innerWidth;
    const height = window.innerHeight;

    canvas.width = width;
    canvas.height = height;

    controls = new Controls(canvas, width, height);


    renderer = new WebGLRenderer({
        canvas,
        antialias: true
    });

    renderer.gammaOutput = true;

    renderer.setSize(width, height);

    ctx.scene.fog = new FogExp2( 0x000000, 0.0128 );
    renderer.setClearColor( ctx.scene.fog.color, 1 );

    const groundGeo = new PlaneBufferGeometry(10000, 10000);
    const groundMat = new MeshLambertMaterial({
        color: 0x080008
    });


    const ground = new Mesh(groundGeo, groundMat);
    ctx.scene.add( ground );

    // Add the lights
    const ambientLight = new AmbientLight(0x5b678c);
    ctx.scene.add(ambientLight);

    light = new PointLight(0xffeaa6, 1.2, 200);
    light.position.set( -3, 3, 3 );

    ctx.scene.add( light );

    //window.addEventListener("keydown", logKeyCode, true);

    Stats.update("Keys", "WASD/cursors to thrust/steer, mouse-click thrusts forward");

    ctx.world = new Cannon.World();
    //ctx.world.gravity.set(0,0,-9);
    ctx.world.broadphase = new Cannon.NaiveBroadphase();
    ctx.world.solver.iterations = 10;

    // Materials
    const defaultMaterial = new Cannon.Material("DEFAULT");
    // Adjust constraint equation parameters for ground/ground contact

    ctx.defaultMaterial = defaultMaterial;

    const def_def_cm = new Cannon.ContactMaterial(defaultMaterial, defaultMaterial, {
        friction: 0.3,
        restitution: 0.2
        // contactEquationStiffness: 1e8,
        // contactEquationRelaxation: 3,
        // frictionEquationStiffness: 1e8,
        // frictionEquationRegularizationTime: 3
    });
    ctx.world.addContactMaterial(def_def_cm);

    const ship_def_cm = new Cannon.ContactMaterial(SHIP_MATERIAL, defaultMaterial, {
        friction: 0.9,
        restitution: 0.2
        // contactEquationStiffness: 1e8,
        // contactEquationRelaxation: 3,
        // frictionEquationStiffness: 1e8,
        // frictionEquationRegularizationTime: 3
    });
    // Add contact material to the world
    ctx.world.addContactMaterial(ship_def_cm);

    const ship_track_cm = new Cannon.ContactMaterial(SHIP_MATERIAL, TRACK_MATERIAL, {
        friction: 0.05,
        restitution: 1
        // contactEquationStiffness: 1e8,
        // contactEquationRelaxation: 3,
        // frictionEquationStiffness: 1e8,
        // frictionEquationRegularizationTime: 3
    });
    // Add contact material to the world
    ctx.world.addContactMaterial(ship_track_cm);


    const groundShape = new Cannon.Plane();

    const groundBody = new Cannon.Body({
        mass: 0, // static
        shape: groundShape,
        material: SHIP_MATERIAL

    });
    groundBody.position.set(0,0,0);

    ctx.world.add(groundBody);


    const track = new Track(TRACK_DATA, ctx);
    //console.log("Track JSON:  " + JSON.stringify(track).length + "bytes");

    ctx.track = track;

    const start = track.getStartPosition();

    const xRacer = new XRacer(start, controls, ctx);
    ctx.entities.add(xRacer);

    for (let i=0; i < 100; i++)
    {
        const x = Math.random() * 20 - 10;

        const v = new Vector3(x < 0 ? x - 4 :  x + 4, -2.5 + Math.random() * 200, 0);

        const v2 = v.clone();

        const segments = ctx.track.data;
        let center,quat;
        for (let i = 0; i < segments.length; i++)
        {
            const segment = segments[i];

            const length = segment.length;
            if (v.y < length)
            {
                let index = 0;
                while (ctx.track.segments[index] !== i)
                {
                    index++;
                }
                center = ctx.track.positions[index].clone();
                center.z -= segment.radius;
                quat = ctx.track.quats[index];
                break;
            }
            v.y -= length;
        }

        if (quat)
        {
            v.applyQuaternion(quat).add(center);
            const cube = new Cube(v, ctx, 0.5 + Math.random() * 2.5);

            cube.body.quaternion.copy(quat);
            ctx.entities.add(
                cube
            )
        }
    }

    camera = new PerspectiveCamera( 75, width / height, 0.1, 200);
    camera.up.set( 0, 0, 1);
    camera.position.x = start.x + CAMERA_OFFSET_X;
    camera.position.y = start.y + CAMERA_OFFSET_Y;
    camera.position.z = start.z + CAMERA_OFFSET_Z;
    camera.updateProjectionMatrix();
    camera.lookAt(start);
    
    prevTime = Date.now() - 1;
    raf(mainLoop);
}


window.onload = function ()
{
    const loader = new JSONLoader();
    const textureLoader = new TextureLoader();

    Promise.all([
        Track.load(textureLoader),
        XRacer.load(loader),
    ])
    .then(init);
};




// WEBPACK FOOTER //
// ./src/main.js